<tr class="wa-table__row calendar__event" *ngIf="Event.isCancelled===false">
  <td class="wa-table__cell calendar__event__logo" [ngClass]="{'is-featured': Event.isfeatured}">
    <img [lazyLoad]="'//extranet.worldarchery.sport/CompetitionLogos/?Id=' + Event?.id?.toString()" class="visibility--hide-mobile" />
  </td>

  <td class="wa-table__cell calendar__event__name">
    <div>
      <a *ngIf="Event.statusId <=1; else noActive" [href]="lang + 'competition/'+Event?.id?.toString()" class="calendar__event__name" data-th="name">

        {{ Event.nameshort !== '' && Event.nameshort ? Event.nameshort : Event.name }}
      </a>
      <ng-template #noActive>
      <div  [ngClass]="{'uppercase-no-viewport':true}" [title]="Event.status" [ngStyle]="{'cursor':'default', 'color':'#989898'}"  class="calendar__event__name" data-th="name">

        {{ Event.nameshort !== '' && Event.nameshort ? Event.nameshort : Event.name }}
      </div>
    </ng-template>
    </div>
  </td>

  <td class="wa-table__cell calendar__event__place">
    <div>{{ Event.place }}</div>
    <img [lazyLoad]="Event.flag" class="flag" />{{ Event.countryName }}
  </td>

  <td class="wa-table__cell calendar__event__date">
    <div *ngIf="Event?.dateFromObj?.getFullYear() !== Event?.dateToObj?.getFullYear()">
      <div>{{ Event.dateFromObj | date :'d MMMM yyyy' }}</div>
      <div>{{ Event.dateToObj | date : 'd MMMM yyyy' }}</div>
    </div>
    <div *ngIf="(Event?.dateFromObj?.getFullYear() === Event?.dateToObj?.getFullYear()) && Event?.dateFromObj?.getDate() === Event?.dateToObj?.getDate()">
      <div>{{ Event.dateToObj | date : 'd MMMM' }}</div>
      <div>{{ Event.dateToObj | date : 'yyyy' }}</div>
    </div>
    <div *ngIf="(Event?.dateFromObj?.getUTCDate() !== Event?.dateToObj?.getUTCDate()) && (Event?.dateToObj?.getMonth() === Event?.dateFromObj?.getMonth())">
      <div>{{ Event.dateFromObj | date : 'd '}} - {{Event.dateToObj | date : 'd MMMM' }}</div>
      <div>{{ Event.dateToObj | date : 'yyyy' }}</div>
    </div>
    <div *ngIf="(Event?.dateFromObj?.getUTCDate() !== Event?.dateToObj?.getUTCDate()) && (Event?.dateToObj?.getMonth() !== Event?.dateFromObj?.getMonth())">
      <div>{{ Event.dateFromObj | date : 'd MMMM'}} - {{Event.dateToObj | date : 'd MMMM' }}</div>
      <div>{{ Event.dateToObj | date : 'yyyy' }}</div>
    </div>
  </td>

  <td class="wa-table__cell calendar__event__quicklinks">
    <div>
      <a [href]="Event.links['Registration URL']" *ngIf="Event.links && Event.links['Registration URL']" class="icon--registration">{{'Registration' | transloco}}</a>
      <a [href]="Event.youtubelive" *ngIf="Event.youtubelive!==''" class="icon--live">{{ Event.youtubelive ?
        Event.youtubelive : '' }} {{'Live' | transloco}}</a>
      <a [href]="Event.webUrl" *ngIf="Event.results" class="icon--medal">{{'Results' |transloco}}</a>
    </div>
  </td>

  <td class="wa-table__cell wa-table__cell--fit-left">
    <div class="list-row-item__action" (click)="onClick()">
      <span class="plus-minus {{ showDetails === false ? 'plus-minus--more' : 'plus-minus--less' }}"></span>
    </div>
  </td>
</tr>

<tr class="wa-table__row wa-table__row--simple">
  <td class="wa-table__cell wa-table__cell--fit" colspan="100%">
    <app-calendar-detail [event]="Event" *ngIf="showDetails === true"></app-calendar-detail>
  </td>
</tr>
